<template>
  <div class="tags project-hours-tags" :class="layout">
    <el-tag :size="size" :type="(project.prospect) ? 'warning' : 'success'">{{ (project.prospect) ? 'Prospect' : 'Approved' }}</el-tag>
    <el-tag :size="size" :type="tagTypeDue" v-if="project.due_date">Due: {{ dueDate }}</el-tag>
    <el-tag :size="size" type="info" v-if="project.est_hours <= 0">{{ totalTimeHours }}hrs / {{ costUsed | formatCurrency }}</el-tag>
    <el-tag :size="size" type="primary" v-if="project.est_hours > 0">Quoted: {{ project.est_hours }}hrs / {{ estimatedCost | formatCurrency }}</el-tag>
    <el-tag :size="size" :type="tagTypeUsed" v-if="project.est_hours > 0">Used: {{ totalTimeHours }}hrs / {{ costUsed | formatCurrency }}</el-tag>
    <el-tag :size="size" :type="tagTypeUsed" v-if="project.est_hours > 0">Left: {{ hoursRemaining }}hrs / {{ costRemaining | formatCurrency }}</el-tag>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mixin as Utils } from '../../mixins/Utils'

  export default {
    name: 'project-hours-tags',
    mixins: [Utils],
    props: {
      size: {
        default: 'small'
      },
      layout: {
        default: 'inline'
      },
      project: null
    },
    computed: {
      dueDate () {
        let thisYear = moment().year()
        let date = moment(this.project.due_date)
        let dateFormat = (date.year() !== thisYear) ? 'ddd Do MMM YYYY' : 'ddd Do MMMM'
        return moment(this.project.due_date).format(dateFormat)
      },
      totalTimeHours () {
        if (this.project.total_time > 0) {
          return Math.round(this.project.total_time / 60 / 60)
        }
        return 0
      },
      estimatedCost () {
        return this.project.est_hours * this.project.hourly_rate
      },
      costUsed () {
        return this.totalTimeHours * this.project.hourly_rate
      },
      hoursRemaining () {
        return Math.round(this.project.est_hours - this.totalTimeHours)
      },
      costRemaining () {
        return (this.project.est_hours - this.totalTimeHours) * this.project.hourly_rate
      },
      tagTypeUsed () {
        if (this.project.est_hours > 0) {
          // If the job is over 100% of quoted time then we use danger
          if (this.totalTimeHours > this.project.est_hours) {
            return 'danger'
          } else if (this.totalTimeHours > (this.project.est_hours * 0.75)) { // 75% of time used
            return 'warning'
          }
        }
        return 'success'
      },
      tagTypeDue () {
        let now = moment()
        let dueDate = moment(this.project.due_date)
        let daysUntilDue = dueDate.diff(now, 'days')

        if (daysUntilDue < 7) {
          return 'danger'
        } else if (daysUntilDue < 14) {
          return 'warning'
        }
        return 'success'
      }
    }
  }
</script>
<style lang="less" rel="stylesheet/less" scoped>
  .project-hours-tags {
    &.stack {
      .el-tag {
        display: block;
        text-align: center;
        margin-bottom: 3px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
